import React from 'react';

const SvgDo = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="DO_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="DO_svg__b" fill="#fff">
        <use xlinkHref="#DO_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#083D7A"
        mask="url(#DO_svg__b)"
        d="M0 0h12v8H0zM16 12h12v8H16z"
      />
      <path
        fill="#DF1E35"
        mask="url(#DO_svg__b)"
        d="M0 12h12v8H0zM16 0h12v8H16z"
      />
      <path
        d="M13.867 8.339a1.667 1.667 0 1 0 1.794 1.794l-1.794-1.794z"
        stroke="#0F6D1A"
        strokeWidth={0.667}
        mask="url(#DO_svg__b)"
        transform="rotate(-45 14 10)"
      />
      <circle fill="#042F60" mask="url(#DO_svg__b)" cx={14} cy={10} r={1} />
    </g>
  </svg>
);

export default SvgDo;
